"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newInvokeIosV2 = exports.getCallbackNameV2 = void 0;

require("core-js/modules/es.regexp.exec.js");

var _utils = require("./utils");

function actualCallbackV2(callback, del, key) {
  var callbackName = 'zzcallbackV2_' + (0, _utils.uniqId)() + '_' + key;

  try {
    var callbackFn = function callbackFn(state, res) {
      try {
        // logInfo('sdk----------------------sdk')
        // logInfo('客户端返回的state:', state, '返回的数据:', res)
        // logInfo('sdk----------------------sdk')
        // logInfo('')
        switch (state) {
          case '200':
            (0, _utils.logInfo)('sdk日志--->执行成功，执行回调', res);
            res = /^\{.*\}$/.test(res) ? JSON.parse(res) : res;
            callback(res);
            break;

          case '201':
            (0, _utils.logInfo)('sdk日志--->找到 Native 方法, 不执行回调');
            break;

          case '402':
            (0, _utils.logInfo)('sdk日志--->参数不合法, 不执行回调');
            break;

          case '403':
            (0, _utils.logInfo)('sdk日志--->缺少权限, 不执行回调');
            break;

          case '404':
            (0, _utils.logInfo)('sdk日志--->找不到 Native 方法, 不执行回调');
            break;

          default:
            (0, _utils.logInfo)('sdk日志--->未知错误, 参考返回的数据, 不执行回调');
            break;
        }

        if (del) delete window[callbackName];
        if (del && window.parent !== window) delete window.top[callbackName];
      } catch (error) {
        (0, _utils.logWarn)('sdk日志--->解析发生错误', error);

        try {
          window['@zz-common/zz-jssdk'].default.sendLegoTrace({
            pageType: '',
            mPage: '',
            actionType: 'feCallbackParseJsonError',
            dataMap: {
              api: '',
              paramJson: res
            }
          });
        } catch (error) {
          (0, _utils.logWarn)(error);
        }
      }
    };

    window[callbackName] = callbackFn;
    if (window.parent !== window) window.top[callbackName] = callbackFn;
  } catch (error) {
    (0, _utils.logWarn)(error);
  }

  return callbackName;
}

function andrExecuteV2(action, param) {
  (0, _utils.logInfo)('sdk----------------------sdk'); // logInfo('andrv2接口请求')

  (0, _utils.logInfo)('param:' + JSON.stringify(param));
  (0, _utils.logInfo)('action:' + action);
  (0, _utils.logInfo)('sdk----------------------sdk');
  (0, _utils.logInfo)('');

  try {
    if (window.zhuanzhuanMApplication) {
      var oriParam = JSON.stringify(param);
      window.zhuanzhuanMApplication.executeCmd('v2', action, oriParam);
    }
  } catch (error) {
    throw new Error('安卓-sdk执行错误', error);
  }
}
/**
 * iosNewExecute
 * @description 调用ios 外放的接口call 发送参数
 * @ignore
 */


function iosNewExecuteV2(action, param) {
  (0, _utils.logInfo)('sdk----------------------sdk'); // logInfo('iosv2接口请求')

  (0, _utils.logInfo)('param:' + JSON.stringify(param));
  (0, _utils.logInfo)('action:' + action);
  (0, _utils.logInfo)('sdk----------------------sdk');
  (0, _utils.logInfo)('');

  try {
    if (window.zhuanzhuanMApplicationIos) {
      var oriParam = JSON.stringify(param);
      window.zhuanzhuanMApplicationIos.callV2('v2', action, oriParam);
    }
  } catch (error) {
    throw new Error('IOS-sdk执行错误', error);
  }
}

var newInvokeIosV2 = function newInvokeIosV2(action, param, callback) {
  param['callback'] = callback;
  if (_utils.isIOS) iosNewExecuteV2(action, param);
  if (_utils.isAndroid) andrExecuteV2(action, param);
};

exports.newInvokeIosV2 = newInvokeIosV2;

var getCallbackNameV2 = function getCallbackNameV2(callback) {
  var del = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var key = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _utils.isFunction)(callback) ? actualCallbackV2(callback, del, key) : '';
};

exports.getCallbackNameV2 = getCallbackNameV2;